export default {
  id: 'closeAndArchiveClass',
  code: 'CN',
  text: {
    'Close Class': '关闭班级',
    "After closing the class, you can find it under the 'Closed Class": "关闭班级后，此班级会显示在 '已关闭班级'",
    'Are you sure you want to close the class below?': '确认关闭班级？',
    'Close Private Class': '关闭私课',
    "After closing the class, you can find it under the 'Closed Private Class": "关闭私课后，此私课会显示在 '关闭私课'",
    'Are you sure you want to close the private class below?': '确认关闭私课？',
    '': '',

  }
}



// WEBPACK FOOTER //
// ./src/process/class/locale.js